<script lang="ts" setup>
import { onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import PhoneNumberInputGroup from "@/components/molecules/form/PhoneNumberInputGroup.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { useCustomRouter } from "@/utils/router";

const customRouter = useCustomRouter();
const router = useRouter();

const phoneNumber = ref("");

onBeforeMount(() => {
  phoneNumber.value = authStore.temporaryPhoneNumber as string;
});

async function nextStep() {
  authStore.changePhoneNumber(phoneNumber.value);
  await customRouter.pushIgnoreError({ name: "RegisterPhoneNumberAuth" });
}

function onClickBack() {
  router.back();
}
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      電話番号認証
    </Header>
    <div class="my-5 mx-4">
      <p class="mb-5 text-size-14">
        過去のバージョンで登録済みのユーザーです。<br />アカウント引き継いでご利用される場合は「次へ」をタップしてください。
      </p>
      <CustomValidationObserver
        v-slot="{ handleSubmit }"
        tag="div"
        class="w-100"
        :initialValues="{ phoneNumber }"
      >
        <BForm @submit.stop.prevent="handleSubmit(nextStep)">
          <ValidationField
            v-slot="validationState"
            label="携帯電話番号"
            rules="required|numeric|length:11"
            name="phoneNumber"
          >
            <PhoneNumberInputGroup
              v-model="phoneNumber"
              disabled
              placeholder="携帯電話番号"
              innerIconType="phoneNumber"
              class="mb-3"
              :validation-state="validationState"
            />
          </ValidationField>

          <AppButton block rounded @click="handleSubmit(nextStep)">
            次へ
          </AppButton>
        </BForm>
      </CustomValidationObserver>
    </div>
  </div>
</template>
